export function buildDynamicHours () {
  const now = new Date()
  // 'Mon Sep 18 2023 13:19:35 GMT+0200 (hora de verano de Europa central)'

  const hours = now.getHours()
  const minutes = now.getMinutes()
  const isHalf = minutes >= 30

  const TIMETABLE = Object.freeze({
    START: 9,
    END: 20,
    TOMORROW: 'amanhã',
    CALL_CENTER_CLOSE: [
      '9:00',
      '9:30',
      '10:00',
      '10:30',
      '11:00',
      '11:30',
      '12:00',
      '12:30',
      '13:00',
      '13:30',
      '14:00',
      '14:30',
      '15:00',
      '15:30',
      '16:00',
      '16:30',
      '17:00',
      '17:30',
      '18:00',
      '18:30',
      '19:00',
      '19:30',
      '20:00'
    ]
  })
  const createArray = Array(24).fill(null)

  let schedule = []
  const nextHour = isHalf ? hours + 1 : hours

  for (let i = 0; i <= createArray.length; i++) {
    const incrementHour = hours + i + 1

    if (hours <= TIMETABLE.START) {
      schedule = TIMETABLE.CALL_CENTER_CLOSE
      break
    }

    if (i === 0 && !isHalf && hours < TIMETABLE.END) {
      schedule.push(`${nextHour}:${nextHour !== hours ? '00' : '30'}`)
    }

    if (incrementHour <= TIMETABLE.END) {
      schedule.push(`${incrementHour}:00`)
      incrementHour !== TIMETABLE.END && schedule.push(`${incrementHour}:30`)
    }
  }

  const hoursForTomorrow = hours - TIMETABLE.START

  for (let i = 0; i <= hoursForTomorrow; i++) {
    if (i <= 10) {
      schedule.push(`${TIMETABLE.TOMORROW} ${TIMETABLE.START + i}:00`)
      schedule.push(`${TIMETABLE.TOMORROW} ${TIMETABLE.START + i}:30`)

      if (hoursForTomorrow === i) {
        schedule.push(`${TIMETABLE.TOMORROW} ${hours + 1}:00`)
      }

      if (i === 10) {
        schedule.push(`${TIMETABLE.TOMORROW} ${TIMETABLE.END}:00`)
      }
    }
  }

  return schedule
}
